
import React from "react";
import { getTableRowCheckBox } from "../../utils/table";
import ActionButtonWithIcons from "../../components/common/ActionButtonWithIcons";
import { faArrowRight, faClone, faDeleteLeft,faEye, faPen, faTrash } from "@fortawesome/free-solid-svg-icons";
import { apiCall } from "../../middlewares/api";
import { apiCallConsts } from "../../constants/apiCallConsts";


export const getQuestionsColumn = (onActionClick, onRowSelect) => {
  const columns = [
    {
      dataField: 'objectId',
      text: 'Select',
      headerClasses: 'rounded-0 p-3 h-auto',
      formatter: (cell, row) => (
        <div>
          {getTableRowCheckBox(onRowSelect, cell, row?.isSelected, false)}
        </div>
      ),
    },
    {
      dataField: 'text',
      text: 'Question',
      headerClasses: 'rounded-0 p-3 h-auto',
    },
    {
      dataField: 'type',
      text: 'Type',
      headerClasses: 'rounded-0 p-3 h-auto',
    },
    {
      dataField: 'status',
      text: 'Status',
      headerClasses: 'rounded-0 p-3 h-auto',
      formatter: (cell) => (
        <span
          style={{
            display: 'inline-block',
            padding: '4px 10px',
            borderRadius: '4px',
            fontSize: '12px',
            fontWeight: '600',
            color: cell === 'Assigned' ? '#155724' : '#856404',
            backgroundColor: cell === 'Assigned' ? '#d4edda' : '#fff3cd',
            border: `1px solid ${cell === 'Assigned' ? '#c3e6cb' : '#ffeeba'}`,
          }}
        >
          {cell}
        </span>
      ),
    },
    {
      dataField: 'answerOptions',
      text: 'Answer Options',
      headerClasses: 'rounded-0 p-3 h-auto',
      formatter: (cell) => {
        if (!Array.isArray(cell) || cell.length === 0) return '-';

        if (cell.length === 1) {
          return <span style={{ fontSize: '13px' }}>{cell[0]}</span>;
        }

        const visibleOptions = cell.slice(0, 2);
        const hiddenCount = cell.length - 2;

        return (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
            {visibleOptions.map((opt, idx) => (
              <div
                key={idx}
                style={{
                  backgroundColor: '#f1f3f4',
                  color: '#000',
                  padding: '4px 10px',
                  fontSize: '12px',
                  borderRadius: '0px',
                  width: 'fit-content',
                  whiteSpace: 'nowrap',
                  display: 'inline-block',
                }}
              >
                {opt}
              </div>
            ))}
            {hiddenCount > 0 && (
              <div
                style={{
                  backgroundColor: '#f1f3f4',
                  color: '#000',
                  padding: '4px 10px',
                  fontSize: '12px',
                  borderRadius: '0px',
                  width: 'fit-content',
                  whiteSpace: 'nowrap',
                  display: 'inline-block',
                }}
                title={cell.slice(2).join(', ')}
              >
                +{hiddenCount} More
              </div>
            )}
          </div>
        );
      },
    },
    {
      dataField: 'Action',
      text: 'Action',
      headerClasses: 'rounded-0 p-3 h-auto',
      style: { textAlign: 'center' },
      formatter: (cell, row) => {
        return (
          <ActionButtonWithIcons
            options={[
              { icon: faEye, label: 'View' },
              { icon: faPen, label: 'Edit' },
              { icon: faTrash, label: 'Delete' },
              { icon: faClone, label: 'Clone' },
            ]}
            onActionClick={(option) => onActionClick(option, row)}
          />
        );
      },
    },
  ];
  return columns;
};


export const getTemplateColumn = (onActionClick, onRowSelect, roles) => {
  const columns = [
    {
      dataField: 'objectId',
      text: 'Select',
      headerClasses: 'rounded-0 p-3 h-auto',
      formatter: (cell, row) => (
        <div>
          {getTableRowCheckBox(onRowSelect, cell, row?.isSelected, false)}
        </div>
      ),
    },
    {
      dataField: 'templateName',
      text: 'Template Name',
      headerClasses: 'rounded-0 p-3 h-auto',
    },
    {
      dataField: 'assignedTo',
      text: 'Assigned To',
      headerClasses: 'rounded-0 p-3 h-auto',
      formatter: (cell) => {
        const displayLimit = 2;

        if (!Array.isArray(cell) || cell.length === 0) {
          return (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
              <div
                style={{
                  backgroundColor: '#f8f9fa',
                  color: '#333',
                  padding: '4px 10px',
                  fontSize: '12px',
                  borderRadius: '0px',
                  width: 'fit-content',
                  whiteSpace: 'nowrap',
                  display: 'inline-block',

                    padding: '2px 10px',
                    fontSize: '12px',
                    backgroundColor: '#fff3cd',
                    color: '#856404',
                 
                }}
              >
                Assigned None
              </div>
            </div>
          );
        }

        const visibleItems = cell.slice(0, displayLimit);
        const hiddenCount = cell.length - displayLimit;

        return (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
            {visibleItems.map((item, index) => (
              <div
                key={index}
                style={{
                  backgroundColor: '#f8f9fa',
                  color: '#333',
                  padding: '4px 10px',
                  fontSize: '12px',
                  borderRadius: '0px',
                  width: 'fit-content',
                  whiteSpace: 'nowrap',
                  display: 'inline-block',
                }}
              >
                {item}
              </div>
            ))}
            {hiddenCount > 0 && (
              <div
                style={{
                  backgroundColor: '#f8f9fa',
                  color: '#007bff',
                  padding: '4px 10px',
                  fontSize: '12px',
                  borderRadius: '0px',
                  width: 'fit-content',
                  whiteSpace: 'nowrap',
                  display: 'inline-block',
                }}
                title={cell.slice(displayLimit).join(', ')}
              >
                +{hiddenCount} More
              </div>
            )}
          </div>
        );
      },
    },
    {
      dataField: 'noOfQuestions',
      text: 'No of Questions',
      headerClasses: 'rounded-0 p-3 h-auto',
    },
    {
      dataField: 'exchangeValue',
      text: 'Exchange Value',
      headerClasses: 'rounded-0 p-3 h-auto',
    },
    {
      dataField: 'bonusAmount',
      text: 'Bonus Amount',
      headerClasses: 'rounded-0 p-3 h-auto',
    },
    {
      dataField: 'action',
      text: 'Action',
      headerClasses: 'rounded-0 p-3 h-auto',
      style: { textAlign: 'center' },
      formatter: (cell, row) => {
        return (
          <ActionButtonWithIcons
            options={[
              { icon: faEye, label: 'View' },
              { icon: faPen, label: 'Edit' },
              { icon: faTrash, label: 'Delete' },
              { icon: faClone, label: 'Clone' }
            ]}
            onActionClick={(option) => onActionClick(option, row)}
          />
        );
      },
    },
  ];
  return columns;
};



// AssignTemplateColumns.js

const getColums = (type,onActionClick,onRowSelect) => {

  console.log(type)

  if(type == "question")
  {
    return getQuestionsColumn(onActionClick,onRowSelect)
  }

  if(type == "template")
  {
    return getTemplateColumn(onActionClick,onRowSelect)
  }

}

// import your ActionButtonWithIcons or any custom button component

// Example: a simple checkbox generator if you need row selection
// 

const getTableRowCheckBox1 = (onRowSelect, rowId, isSelected, disabled) => {
  return (
    <input
      type="checkbox"
      onChange={() => onRowSelect(rowId)}
      checked={!!isSelected}
      disabled={disabled}
      style={{ cursor: "pointer" }}
    />
  );
};


export const getAssignTemplateColumns = (onActionClick, onRowSelect) => {
  return [
    {
      dataField: "id",
      text: "Select",
      formatter: (cell, row) => (
        <div style={{ textAlign: "center" }}>
          {getTableRowCheckBox1(onRowSelect, row.id, row.isSelected, false)}
        </div>
      ),
    },
    {
      dataField: "vanNo",
      text: "VAN No.",
      
    },
    {
      dataField: "productName",
      text: "Product Name",
     
    }
  ];
};


export const getDataWithPageTitle = (title,onActionClick,onRowSelect,navigate) => {


  const tableColumns =  getColums(title,onActionClick,onRowSelect) 

  console.log(title)
  const onDelete  = getOnDelete(title)
  const onEdit =  getOnEdit(title,navigate)
  const onCreate = getOnCreate(title)
  const getData = getDataInfo(title)
  const assignedToTempate = getAssignedTo(title,navigate)
  const cloneData = getCloneTo(title,navigate)

  return {
    tableColumns,onDelete,onEdit,onCreate,getData,assignedToTempate,cloneData
  }

}


const getAssignedTo = (title,navigate) => {



  return () => {
      navigate("/templete/assign")
  }



}
const getCloneTo = (title,navigate) => {

  if(title == "template")
  {
  return (id) => {
      navigate("/templete/create?clone=true"+"&id="+id)
  }
}
if(title == "question")
{
return (id) => {
    navigate("/question/create?clone=true"+"&id="+id)
}
}

}

const getOnDelete = (title) => {

  if(title == "question")
  {
     const deleteFun = async (objectId) => {

      try{

      const response = await apiCall(apiCallConsts?.DELETE_METHOD,"http://localhost:1338/internal/questions/"+objectId)

      return response

      }catch(error){
        
      }
        
     }

  }


}

const getOnEdit = (title,navigate) => {
  if(title == "question")
  {
  return  (id) => {
      navigate("/question/create"+"?id="+id)
    }
  }
  if(title == "template")
  {
    return  (id) => {
      navigate("/templete/create"+"?id="+id)
    }
  }
  
  
}

const getOnCreate = (title) => {


     if(title == "question")
     {
      return {

        url : "/question/create",
        text : "Create new Question"
      }
    }
     
    if(title == "template")
    {
      return   {
        url : "/templete/create",
        text : "Create new Template"
      }
    }
     
    }

const getDataInfo =  (title) => {
  
  if(title == "question") {
  return fetchExchangeQuestions
}
  if(title == "template") {
   return fetchExchangeTemplates
  }

}


export const fetchExchangeQuestions = async () => {
  try {
    const response = await apiCall(apiCallConsts?.GET_METHOD,'internal/questions');
    return response?.data;
  } catch (error) {
    console.error('Failed to fetch exchange questions:', error.message);
    throw new Error(error?.message)
  }
};


export const fetchExchangeTemplates = async () => {
  try {
    const response = await apiCall(apiCallConsts?.GET_METHOD,'internal/template');
    return response?.data;
  } catch (error) {
    console.error('Failed to fetch exchange questions:', error.message);
    throw new Error(error?.message)
  }
};
